var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIbeifyTwittIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6666 10.8668C21.1655 11.0842 20.6355 11.2279 20.0933 11.2935C20.6654 10.9517 21.0941 10.414 21.2999 9.78014C20.7623 10.1002 20.1738 10.3257 19.5599 10.4468C19.1496 10.0019 18.6032 9.70567 18.0065 9.60471C17.4097 9.50374 16.7963 9.60371 16.2624 9.88893C15.7286 10.1742 15.3045 10.6285 15.0567 11.1807C14.809 11.7329 14.7514 12.3517 14.8933 12.9401C13.8062 12.8852 12.7429 12.6021 11.7724 12.1094C10.8018 11.6167 9.94582 10.9253 9.25992 10.0801C9.01934 10.5003 8.89293 10.976 8.89325 11.4601C8.8924 11.9097 9.00273 12.3526 9.21442 12.7492C9.42611 13.1458 9.7326 13.4839 10.1066 13.7335C9.6719 13.7216 9.24651 13.605 8.86659 13.3935V13.4268C8.86984 14.0567 9.09058 14.6662 9.49146 15.1521C9.89234 15.638 10.4488 15.9706 11.0666 16.0935C10.8288 16.1659 10.5818 16.204 10.3333 16.2068C10.1612 16.2048 9.98953 16.1892 9.81992 16.1601C9.99586 16.702 10.3363 17.1756 10.794 17.5149C11.2516 17.8543 11.8036 18.0425 12.3733 18.0535C11.4114 18.8103 10.2238 19.2234 8.99992 19.2268C8.77708 19.2275 8.55441 19.2142 8.33325 19.1868C9.58287 19.9936 11.0391 20.422 12.5266 20.4201C13.553 20.4308 14.5713 20.2368 15.522 19.8495C16.4726 19.4622 17.3366 18.8894 18.0634 18.1645C18.7902 17.4395 19.3652 16.5771 19.755 15.6274C20.1447 14.6778 20.3413 13.66 20.3333 12.6335V12.2801C20.8564 11.89 21.3076 11.4118 21.6666 10.8668Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIbeifyTwittIcon);
export default __webpack_public_path__ + "static/media/ibeify_twitt_icon.7358f38600292eb2b19570b0096bc17a.svg";
export { ForwardRef as ReactComponent };